import React, { useState, useEffect } from 'react';
import AsideLeft from './AppAdminComponents/AsideLeft';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import { useForm } from "react-hook-form";
import { getuser } from '../helpers/user.helper';
import { useNavigate } from "react-router-dom";
import { ListCustomers } from '../services/customer.service';
import { ListItensDateInterval, FinalizaItens, GetFechamento } from '../services/seller.service';
import AsyncSelect from 'react-select/async';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import formatDate from '../helpers/date.helper';

import ptBR from 'date-fns/locale/pt-BR';
import Footer from '../components/Footer';
registerLocale('ptBR', ptBR);

var Barcode = require('react-barcode');

export default function Fechamento() {
    const [selectedValue, setSelectedValue] = useState(null);
    const [customersArray, setCustomers] = useState(undefined);
    const [vetorFechamentos, setFechamento] = useState(undefined);

    const [showTable, setShowTable] = useState(false);
    const [itensDataTable, setItensDataTable] = useState([]);

    const [isLoaderReport, setIsloaderReport] = useState(false);
    const [isLoaderFinish, setIsloaderFinish] = useState(false);

    const [inputValue, setValue] = useState('');
    const [inputIniDate, setIniDate] = useState('');
    const [inputIniFinish, setFinishDate] = useState('');

    const [showHistoric, setShowHistoric] = useState(false);
    const [showNew, setShowNew] = useState(false);

    const { register, handleSubmit, watch, errors } = useForm();


    let navigate = useNavigate();

    useEffect(() => {
        let user = getuser();
        //Redireciona caso não esteja logado 
        if (!user) {
            navigate('/login');
        }

        async function fetchData() {
            let customers = await ListCustomers();
            let fechamento = await GetFechamento();

            setCustomers(customers?.data);
            setFechamento(fechamento?.data);
        }

        fetchData();
    }, [])

    const handleInputChange = value => {
        setValue(value);
    };

    const handleChange = value => {
        setSelectedValue(value);
    }

    const loadOptions = async (inputValue) => {
        let customers = await ListCustomers();
        return customers.data;
    };

    const generateTable = async (inputValue) => {
        setIsloaderReport(true);
        let customerId = selectedValue.codigo;
        let itens = await ListItensDateInterval(customerId, inputIniDate.toLocaleDateString('en-US'), inputIniFinish.toLocaleDateString('en-US'));
        setItensDataTable(itens?.data)
        setShowTable(true);
        setIsloaderReport(false);
    };

    const FinalizaItensPeriodo = async () => {
        setIsloaderFinish(true);
        let itens = await FinalizaItens(itensDataTable, inputIniDate.toLocaleDateString('en-US'), inputIniFinish.toLocaleDateString('en-US'));
        setIsloaderFinish(false);

        navigate('/fechamento');
        toast.info('Fechamento criado!');
    };

    const barcodeLine = (rowData, column) => {
        return (
            <div>
                <Barcode value={rowData.codProduto} height={10} fontSize={12} displayValue={false} />
            </div>
        )
    }

    const setVisiblenewHeader = () => {
        setShowNew(!showNew);
    }

    const setVisibleHistoric = () => {
        console.log('passou setVisibleHistoric', showHistoric);
        setShowHistoric(!showHistoric);
    }

    return (
        <>
            <div className="wrapper">

                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />
                </nav>
                <AsideLeft option="fechamento" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">Fechamento de Mês</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* Left col */}
                                <section className="col-lg-12 connectedSortable">
                                    <div className="card">
                                        <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setVisiblenewHeader()}>
                                            Novo fechamento
                                            <div className="card-tools">
                                                <ul className="nav nav-pills ml-auto">
                                                    {/* <li className="nav-item">
                                                        <a className="nav-link active" href="/venda/nova" data-toggle="tab">Nova</a>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className={showNew ? "card-body" : "card-body collapse"}>
                                            <form >
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <label >Cliente</label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                defaultOptions
                                                                value={selectedValue}
                                                                getOptionLabel={e => e.nome}
                                                                getOptionValue={e => e.codigo}
                                                                loadOptions={loadOptions}
                                                                onInputChange={handleInputChange}
                                                                onChange={handleChange}
                                                            />
                                                            {errors.nome && <span>Campo obrigatório</span>}
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="row">
                                                <label >Data inicial</label>
                                                    <div className="col-12">
                                                        <div className="form-group">                                                            
                                                            <DatePicker selected={inputIniDate} onChange={date => setIniDate(date)} locale="ptBR" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <label >Data Final</label>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <DatePicker selected={inputIniFinish} onChange={date => setFinishDate(date)} locale="ptBR" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <button className="btn btn-primary" onClick={() => generateTable()} id="noprint" ><span className={isLoaderReport ? ' spinner-border spinner-border-sm' : ''}></span> Gerar relatório</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>

                                            {
                                                showTable &&
                                                <DataTable value={itensDataTable} style={{ marginBottom: 50 }}
                                                    responsive
                                                    className="p-datatable-customers"
                                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                                                    emptyMessage="Não encontramos vendas não lançadas para as datas e clientes escolhidos"
                                                >
                                                    <Column field="codProduto" header="Produto" />
                                                    <Column field="descricao" header="Descrição" />
                                                    <Column key="123" body={barcodeLine} bodyStyle={{ textAlign: 'center', overflow: 'hidden' }} />
                                                </DataTable>
                                            }

                                            {
                                                showTable &&
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <button className="btn btn-primary" disabled={itensDataTable.length == 0} onClick={() => FinalizaItensPeriodo()} id="noprint" ><span className={isLoaderFinish ? ' spinner-border spinner-border-sm' : ''}></span> Fechar período</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>


                                    <div className="card">
                                        <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setVisibleHistoric()}>
                                            Histórico de fechamentos
                                            <div className="card-tools">
                                                <ul className="nav nav-pills ml-auto">
                                                    {/* <li className="nav-item">
                                                        <a className="nav-link active" href="/venda/nova" data-toggle="tab">Nova</a>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className={showHistoric ? "card-body" : "card-body collapse"}>
                                            {
                                                vetorFechamentos &&
                                                <DataTable value={vetorFechamentos} style={{ marginBottom: 50 }}
                                                    responsive
                                                    className="p-datatable-customers"
                                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                                                    emptyMessage="Voc~e ainda não realizou nenhum fechamento ou não tem acesso a fechamentos."
                                                >
                                                    <Column field="id" header="Id" />
                                                    <Column field={(row) => formatDate(row.dataFechamento)} header="Data" />
                                                    <Column field="responsavel" header="Responsavel" />
                                                    <Column field="vendedor" header="Cliente" />
                                                    <Column field="vendedor" header="Periodo do Fechamento" />
                                                </DataTable>
                                            }
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        </>
    )
}
